import APTable, { APTableProps } from "../../components/APTable";
import { toDollars } from "../../helpers/currencies";
import { PeriodicAmounts } from "../../types/Calculation";

type TableDataDefinition = {
  name: string;
  term: string;
  annual: string;
  month: string;
  fortnight: string;
  week: string;
};

const APPeriodicCalculations = ({
  calculations,
  highlightRows = false,
}: {
  calculations: { name: string; amounts: PeriodicAmounts<number> }[];
  highlightRows?: boolean;
}) => {
  const tableProps: APTableProps<TableDataDefinition> = {
    columns: ["name", "term", "annual", "month", "fortnight", "week"],
    headerRows: {
      term: { title: "Term" },
      annual: { title: "Annual" },
      month: { title: "Month" },
      fortnight: { title: "Fortnight" },
      week: { title: "Week" },
    },
    rows: calculations.map((calculation) => {
      return {
        name: calculation.name,
        term: toDollars(calculation.amounts.total, 2),
        annual: toDollars(calculation.amounts.annual, 2),
        month: toDollars(calculation.amounts.monthly, 2),
        fortnight: toDollars(calculation.amounts.fortnightly, 2),
        week: toDollars(calculation.amounts.weekly, 2),
      };
    }),
    totalRow: {},
    showTotalRow: false,
    highlightRows,
  };

  return <APTable {...tableProps} />;
};

export default APPeriodicCalculations;
